import styled from 'styled-components'
import border from '../../../tokens/border'
import typography from '../../../tokens/typography'
import colors from '../../../tokens/colors'
import { composeTheme } from '../../../utils/compose-theme'

export const Toggler = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  background-color: ${(props) =>
    props.theme.brandColors?.sideMenuBackgroundColor
      ? props.theme.brandColors.sideMenuBackgroundColor
      : colors.neutralColorHighPure};
  border: ${border.width.widthHairline} solid
    ${(props) =>
      props.theme.brandColors
        ? props.theme.brandColors.sideMenuDividerColor
        : colors.neutralColorLowLight};
  border-radius: ${border.radius.radiusCircular};
  color: ${(props) =>
    props.theme.brandColors?.sideMenuFontColor
      ? props.theme.brandColors.sideMenuFontColor
      : colors.neutralColorLowLight};
  cursor: pointer;
  display: flex;
  font-size: ${typography.fontSize.fontSizeXxs};
  height: 2.8rem;
  justify-content: center;
  position: absolute;
  right: -1.4rem;
  top: 1.5rem;
  transition: color 0.25s;
  width: 2.8rem;
  z-index: 2;
`
